import { Bindings } from "booking_app/types";

declare var angular: any;

export class BookingAdditionalChargeNoticeController {
  static $inject = [];

  data: any;

  constructor() {}
}

angular.module("BookingApp").component("bookingAdditionalChargeNotice", {
  bindings: {
    data: Bindings.ONE_WAY,
  },
  controller: BookingAdditionalChargeNoticeController,
  template: `
    <div class="pay-at-property-callout-container stay-detail">
      <div class="pay-at-property-callout-header">
        <span translate="checkout.tax_breakdown.pay_at_property_callout_header" />
      </div>
      <div class="pay-at-property-callout-content">
        <span ng-bind-html="'checkout.tax_breakdown.pay_at_property_callout_content_2' | translate: {
          currency: $ctrl.data.price_breakdown_metadata.excluded_taxes_and_fees[0].currency,
          amount: $ctrl.data.price_breakdown_metadata.excluded_taxes_and_fees_total,
        }" />
      </div>
    </div>
  `
});
